// extracted by mini-css-extract-plugin
export var footer = "_qc-5";
export var fulfillmentInput = "_qc-0";
export var shipDateInput = "_qc-1";
export var shipmentModal = "_qc-2";
export var shipmentModalContent = "_qc-3";
export var tableContainer = "_qc-4";